import React from 'react';

const NotFound = () => (
    <div className='notfound'>
        <h2>The Page is Not Found</h2>
    </div>
)

export default NotFound;